import * as React from 'react';

const STEP1 = {
  target: '[data-tour="my-property__taxes-rule"]',
  content: <p>Подача обращений на актуализацию объектов имущества и применения льготы к ним</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP2 = {
  target: '[data-tour="my-property__help"]',
  content: (
    <p>
      Здесь содержится скомпонованная в разделы информация с ответами на часто задаваемые вопросы,
      связанные с имуществом в Личном кабинете налогоплательщика
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP3 = {
  target: '[data-tour="mainmenu__report"]',
  content: <p>Раздел со списком услуг, предоставляемых налоговыми органами</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP4 = {
  target: '[data-tour="mainmenu__messages"]',
  content: (
    <p>
      Раздел с сообщениями из налоговых органов, а также историей и статусами поданных обращений
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP5 = {
  target: '[data-tour="footer__help"]',
  content: (
    <p>
      Ведет на страницу с ответами на часто задаваемые вопросы о личном кабинете налогоплательщика и
      ссылками на полезные сервисы
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP6 = {
  target: '[data-tour="footer__siteMap"]',
  content: <p>Ведет на страницу Карты сайта с возможностью перейти на нужную страницу</p>,
  hideCloseButton: true,
  disableBeacon: true,
  hideSkipButton: true,
};

const STEPS_MY_PROPERTY = [STEP1, STEP2, STEP3, STEP4, STEP5, STEP6];
export default STEPS_MY_PROPERTY;
